import api from '../utils/api';

/** One clash from `POST /appointments/:id/check-conflicts`; a time-block clash has no appointment. */
export interface AppointmentConflict {
  type: 'veterinarian' | 'horse' | 'time_block';
  message: string;
  conflictingAppointment?: { id: string; visitGroupId?: string | null };
}

export interface ConflictCheck {
  hasConflict: boolean;
  conflicts: AppointmentConflict[];
}

/** One person's Schedule settings; null = the default. */
export interface SchedulePreferences {
  slotMinutes: 15 | 30 | 60 | null;
  dayStartHour: number | null;
  dayEndHour: number | null;
  unassignedColumn: 'auto' | 'always' | 'never' | null;
}

export const appointmentService = {
  getSchedulePreferences: async (): Promise<SchedulePreferences> => {
    const response = await api.get('/users/me/schedule-preferences');
    return response.data;
  },

  saveSchedulePreferences: async (patch: Partial<SchedulePreferences>): Promise<SchedulePreferences> => {
    const response = await api.put('/users/me/schedule-preferences', patch);
    return response.data;
  },

  /** The clinic's active equipment units (the Schedule's Day by equipment columns). */
  listEquipment: async (): Promise<Array<{ id: string; name: string; type?: string | null }>> => {
    const response = await api.get('/equipment');
    return response.data;
  },

  /** Every time block and clinic closure (the calendar filters to its range). */
  listTimeBlocks: async (): Promise<any[]> => {
    const response = await api.get('/time-blocks');
    return response.data;
  },

  /** Would this appointment at the new time and vet clash? Online only: the check is not replicated. */
  checkConflicts: async (
    appointmentId: string,
    body: { newDate: string; newDuration: number; newAssignedVetId?: string | null; timeZone: string },
  ): Promise<ConflictCheck> => {
    const response = await api.post(`/appointments/${appointmentId}/check-conflicts`, body);
    return response.data;
  },
};
